module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ca4e1d756a09cf9e75b48df72cc558ce.png";